import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "template",
    "groups",
    "group"
  ]

  append(e) {
    e.preventDefault();
    const generated = this.generate();
    this.groupsTarget.appendChild(generated);
  }

  remove(e) {
    e.preventDefault();
    const generated = this.generate();
    const index = this.findIndex(e.currentTarget);
    this.groupTargets[index].remove();
    for(let i=index; i<this.groupTargets.length; i++) {
      this.refreshIndex(i);
    }
  }

  up(e) {
    e.preventDefault();
    const index = this.findIndex(e.currentTarget);
    if(index === 0) { return; }
    this.groupsTarget.insertBefore(this.groupTargets[index], this.groupTargets[index - 1]);
    this.refreshIndex(index - 1);
    this.refreshIndex(index);
  }

  down(e) {
    e.preventDefault();
    const index = this.findIndex(e.currentTarget);
    if(index === this.groupTargets.length - 1) { return; }
    this.groupsTarget.insertBefore(this.groupTargets[index], this.groupTargets[index + 1].nextSibling);
    this.refreshIndex(index + 1);
    this.refreshIndex(index);
  }

  // テンプレートから値つきのhtmlを生成する
  generate(value) {
    const div = document.createElement("div");
    div.dataset.target = "dynamic-field-groups.group";
    div.innerHTML = this.template;

    const index = this.groupTargets.length;
    const inputs = div.querySelectorAll("input,select,textarea");
    inputs.forEach(input => {
      const name = input.name.match(/\[([^\[]+)\]$/)[1];
      if (value && value[name]) {
        if (input.type === "checkbox") {
          input.setAttribute("checked", value[name])
        } else {
          input.value = value[name];
        }
      }
      // group_name[field_name] -> group_name[index][field_name] へ変換
      input.name = input.name.replace(new RegExp(`\\[${name}\\]$`), `[${index}][${name}]`)
      // 自動で生成されるidも変換しておく
      input.id = `${input.id}_${index}`
    });
    const labels = div.querySelectorAll("label");
    labels.forEach(label => {
      const forText = label.getAttribute("for");
      label.setAttribute("for", `${forText}_${index}`);
    });
    // indexが必要な要素についても値を置き換える
    const assignments = div.querySelectorAll("[data-dynamic-field-groups-assign]")
    assignments.forEach(asm => {
      const assignTo = asm.dataset.dynamicFieldGroupsAssign;
      const currentAttrVal = asm.getAttribute(assignTo);
      asm.setAttribute(assignTo, currentAttrVal.replace(/_\d+$/, `_${index}`));
    });

    return div;
  }

  findIndex(child) {
    const firedGroup = child.closest("[data-target='dynamic-field-groups.group']");
    return this.groupTargets.indexOf(firedGroup);
  }

  // group内のvalueのindexを順番通りにする
  refreshIndex(targetIndex) {
    const inputs = this.groupTargets[targetIndex].querySelectorAll("input,select,textarea");
    inputs.forEach(input => {
      input.name = input.name.replace(/\[\d+\]\[([^\[]+)\]$/, `[${targetIndex}][$1]`)
      input.id = input.id.replace(/_\d+$/, `_${targetIndex}`)
    });
    // indexが必要な要素についても値を置き換える
    const assignments = this.groupTargets[targetIndex].querySelectorAll("[data-dynamic-field-groups-assign]")
    assignments.forEach(asm => {
      const assignTo = asm.dataset.dynamicFieldGroupsAssign;
      const currentAttrVal = asm.getAttribute(assignTo);
      asm.setAttribute(assignTo, currentAttrVal.replace(/_\d+$/, `_${targetIndex}`));
    });
  }

  connect() {
    // templateから値を取ってきて消す（不要な値が送られないため）
    this.template = this.templateTarget.innerHTML;
    this.templateTarget.remove();

    const defaultValues = JSON.parse(this.element.dataset.defaultValues);
    defaultValues.forEach(v => {
      const generated = this.generate(v);
      this.groupsTarget.appendChild(generated);
    });
    const minFields = Number(this.element.dataset.minFields) || 0;
    const defaultAdditionalFields = minFields - defaultValues.length;
    for(let i = 0; i < defaultAdditionalFields; i++) {
      this.groupsTarget.appendChild(this.generate({}));
    }
  }
}
